module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg1-086846b74215d1014b3f6828fd7c4c0a.jpg";